/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_ORGANIZATION_SUCCESS,
  LOAD_ORGANIZATION_ERROR,
  LOAD_USER_ROLE_SUCCESS,
  LOAD_USER_ROLE_ERROR,
  LOAD_TOKEN_EXPIRY_SUCCESS,
  LOAD_TOKEN_EXPIRY_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_BUSINESS_META_DATA_SUCCESS,
  LOAD_BUSINESS_META_DATA_ERROR,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_ERROR,
  LOAD_USER_ACTIVITIES_SUCCESS,
  LOAD_USER_ACTIVITIES_ERROR,
} from "./constants";

const initialState = {
  organization_list: {},
  user_role_list: [],
  users_list: [],
  token_expiry_list: [],
  user_activities: [],
  record: {},
  recordsMetaData: {},
  businessMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    organization_list,
    token_expiry_list,
    user_role_list,
    users_list,
    user_activities,
    recordsMetaData = {},
    businessMetaData = {},
    error,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ORGANIZATION_SUCCESS:
        draft.organization_list = organization_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_USER_ROLE_SUCCESS:
        draft.user_role_list = user_role_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_USERS_SUCCESS:
        draft.users_list = users_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOKEN_EXPIRY_SUCCESS:
        draft.token_expiry_list = token_expiry_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_USER_ACTIVITIES_SUCCESS:
        draft.user_activities = user_activities;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_BUSINESS_META_DATA_SUCCESS:
        draft.businessMetaData = businessMetaData;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_ORGANIZATION_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_RECORDS_META_DATA_ERROR:
      case LOAD_BUSINESS_META_DATA_ERROR:
      case LOAD_TOKEN_EXPIRY_ERROR:
      case LOAD_USER_ROLE_ERROR:
      case LOAD_USERS_ERROR:
      case LOAD_USER_ACTIVITIES_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
